import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipContent = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 65%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 700px;
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 12px;
  border-radius: 4px;
  word-break: break-all
  text-align: left;
  z-index: 999;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.85) transparent transparent transparent;
  }

  h4 {
    font-family: "RM Neue", "sans-serif";
    font-size: 20px;
    margin: 0 0 8px 0;
    color: white;
  }

  p {
    font-family: "RM Neue", "sans-serif";
    font-size: 1rem;
    margin: 0 0 4px 0;
    color: white;
  }
`;

const GebyrInfoToolTip = (props) => {
    const [visible, setVisible] = useState(false);

  return (
    <TooltipWrapper
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {props.children}
        <TooltipContent visible={visible}>
           <div>
            <h4>Viktig om fakturagebyr: </h4>
            <p>• Dokumentasjonsplikt: Dersom fakturagebyret overstiger kr 10, må bedrifter dokumentere hvordan de har beregnet den faktiske kostnaden.</p>
            <p>• Ny finansavtalelov (1. jan 2023): Fakturagebyr kan ikke overstige de reelle kostnadene for utstedelse og sending av faktura.</p>
            <p>• Forbrukertilsynets vurdering: Kun direkte kostnader ved fakturautstedelse kan inngå - ikke lønn, IT-systemer eller utstyr.</p>
            <p style={{ margin: '0' }}>• Begrensninger på gebyrtyper: Gebyrer uavhengig av navn (f.eks. "miljøgebyr" eller "administrasjonsgebyr") må følge loven.</p>
          </div>
        </TooltipContent>
    </TooltipWrapper>
  );
};

export default GebyrInfoToolTip;
